import * as React from 'react'
import ThinkportLogo from '../../assets/images/sponsors/black-thinkport-horizontal.png'
import WirtschaftsforderungLogo from "../../assets/images/sponsors/wirtschaftsförderung.png"
import MittelhessenLogo from "../../assets/images/sponsors/mittelhessen.png"
import WirtschaftsinitiativeLogo from "../../assets/images/sponsors/wirtschaftsinitiative.png"
import WiBankLogo from "../../assets/images/sponsors/wi-bank.png"
import LpaGvvLogo from "../../assets/images/sponsors/lpa.png"
// import hub31_logo from "../../assets/images/sponsors/hub31-bw.jpeg"

function SponsorsLogos() {
    return (
        <>
        <a href="https://thinkport.digital" target="_blank" rel="noopener noreferrer" className="w-[50%]"  style={{ float: 'left', height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img
                className="lazy loaded"
                style={{ width: 300, margin: 'auto' }}
                src={ThinkportLogo}
                alt="Thinkport Logo" />
        </a>
        <a href="https://www.die-wirtschaftsinitiative.de" target="_blank" rel="noopener noreferrer" className="w-[50%]" style={{ float: 'left', height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img
                className="lazy loaded"
                style={{ width: 300, margin: 'auto' }}
                src={WirtschaftsinitiativeLogo}
                alt="Frankfurt Rhein Main - Die Wirtschaftsinitiative Logo" />
        </a>
        <a href="https://frankfurt-business.net" target="_blank" rel="noopener noreferrer" className="w-[50%]"   style={{ float: 'left', height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img
                className="lazy loaded"
                style={{ width: 300, margin: 'auto' }}
                src={WirtschaftsforderungLogo}
                alt="Wirtschaftsförderung Frankfurt Logo" />
         </a>
         <a href="https://www.wibank.de/wibank" target="_blank" rel="noopener noreferrer" className="w-[50%]" style={{ float: 'left', height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img
                className="lazy loaded"
                style={{ width: 300, margin: 'auto' }}
                src={WiBankLogo}
                alt="WIBank Logo" />
        </a>
        <a href="https://www.foundershub-mittelhessen.de" target="_blank" rel="noopener noreferrer" className="w-[50%]" style={{ float: 'left', height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img
                className="lazy loaded"
                style={{ width: 300, margin: 'auto' }}
                src={MittelhessenLogo}
                alt="Foundershub mittelhessen Logo" />
        </a>
        <a href="https://lpa-ggv.de" target="_blank" rel="noopener noreferrer" className="w-[50%]" style={{ float: 'left', height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img
                className="lazy loaded"
                style={{ width: 120, margin: 'auto' }}
                src={LpaGvvLogo}
                alt="LPA-GGV Law Logo" />
        </a>
        {/* TODO: insert black-white Logo of Hub31 */}
        {/* <a href="https://hub31.de/" target="_blank" rel="noopener noreferrer" className="w-[50%]" style={{ float: 'left', height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img
                className="lazy loaded"
                style={{ width: 120, margin: 'auto' }}
                src={hub31_logo}
                alt="HUB31 Logo" />
        </a> */}
        </>    
    )
}

export default SponsorsLogos
